import { render, staticRenderFns } from "./AddMarketRule.vue?vue&type=template&id=18f44548"
import script from "./AddMarketRule.vue?vue&type=script&lang=js"
export * from "./AddMarketRule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports